export default __webpack_public_path__ + "static/media/spark_34.47d2f001.png";